const Theme = {
  body_background_color: '#0076B6',

  logo_image_url: 'portdequebec.png',
  logo_height: 80,

  button_color: '#0076B6',

  button_radius: 8,

  button_half_border_color: '#0076B6',
  button_border_width: 2,

  title_font: `'Cairo', sans-serif`,
  text_font: `'Cairo', sans-serif`,
}

export default Theme
